import React from 'react';
import Editor from '../components/Editor';

function DashboardPage({ user, token, isDark }) {
  return (
    <div className="space-y-5">
      <header
        className={`fade-in-up rounded-3xl border px-5 py-5 backdrop-blur md:px-6 ${
          isDark ? 'border-slate-700 bg-slate-900/80' : 'border-white/80 bg-white/80'
        }`}
      >
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-500">Dashboard</p>
            <h1 className="text-2xl font-black md:text-3xl">Welcome back, {user?.name || 'Creator'}</h1>
            <p className={`${isDark ? 'text-slate-400' : 'text-slate-600'} mt-1 text-sm`}>{user?.email}</p>
          </div>

          <div
            className={`rounded-full px-3 py-1 text-xs font-semibold ${
              isDark ? 'bg-slate-800 text-slate-200' : 'bg-slate-100 text-slate-700'
            }`}
          >
            Editor + Orders Workspace
          </div>
        </div>
      </header>

      <section className="grid gap-4 md:grid-cols-3">
        {[
          ['AI Templates', 'Prompt-driven postcard generation'],
          ['PDF + PNG', 'Download-ready marketing assets'],
          ['Order Tracking', 'Provider flow + status updates']
        ].map(([title, text], index) => (
          <article
            key={title}
            className={`fade-in-up-${index + 1} rounded-2xl border p-4 ${
              isDark ? 'border-slate-700 bg-slate-900/75' : 'border-white bg-white/80'
            }`}
          >
            <p className="text-xs font-black uppercase tracking-wide text-cyan-500">{title}</p>
            <p className={`mt-2 text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>{text}</p>
          </article>
        ))}
      </section>

      <section className="fade-in-up-2">
        <Editor token={token} theme={isDark ? 'dark' : 'light'} />
      </section>
    </div>
  );
}

export default DashboardPage;
